import FullScreenPhotoList from './FullScreenPhotoList';

export default FullScreenPhotoList;
